import React, { useCallback } from 'react';
import Button from '@material-ui/core/Button';
import GetAppIcon from '@material-ui/icons/GetApp';

import { useStyles } from 'components/struct-map/struct-map-styles';
import { StructMapData } from 'components/struct-map/struct-map-types';

export const BulkActions = () => <></>;

export const NodeActions = () => <></>;

export const LeafActions = ({
  leaf,
  classes,
}: {
  leaf?: StructMapData;
  classes: ReturnType<typeof useStyles>;
}) => {
  const downloadFile = useCallback(async () => {
    window.open(
      process.env.PUBLIC_URL + `/api/file/archival/${leaf?.fileRef?.id}`,
      '_blank'
    );
  }, [leaf]);

  return (
    <Button
      size="small"
      classes={{ root: classes.downloadButton }}
      variant="contained"
      onClick={downloadFile}
    >
      <GetAppIcon className={classes.downloadIcon} />
    </Button>
  );
};
